const BRAND_LETTERS: Record<string, string> = {
    BIC: 'B',
    SupraFlex: 'S',
}

/** Буква бренда пантона: BIC — B, SupraFlex — S. */
export function getBrandLetter(manufacturerName?: string | null) {
    if (!manufacturerName) return ''
    return BRAND_LETTERS[manufacturerName] ?? manufacturerName
}
